import axios from "axios";
import getCookies from "../Util/getCookies";
import { auditErrorRequest } from "../functions/auditErrorRequest";
import { getUTCTime } from '../Util/utcTime'
import { JOURNEY_NAME } from "../Constants/index"

const win: any = window;

const createTransactionID: any = (isCorrelationId: boolean = false) => {
  let currentDateTime = new Date()
    .toISOString()
    .replace(/-|:|T/gi, "")
    .replace(".", "")
    .slice(2)
    .slice(0, -1);
  return (
    "POR" +
    (isCorrelationId ? "C" : "") +
    currentDateTime +
    "_" +
    Math.ceil(Math.random() * 100000)
  );
};

let config = {
  api: {
    baseURL: "",
    headers: {
      "Content-Type": "application/json",
      Authorization: "",
      "x-api-key": "",
      "X-Correlation-Id": "",
      "X-Source-Channel": "PORTAL",
      "X-Transaction-Id": "",
    },
  },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();
export const inquiryApi = axios.create({ ...config.api })

api.interceptors.request.use(
  async (conf: any) => {
    const poid = getCookies("device-poid");
    const journeyName = getCookies("device-journeyName");

    conf.baseURL = win["apigee_bm_base_url"];
    conf.headers.Authorization = `Bearer ${win["bmToken"]}`;
    conf.headers["x-api-key"] = win["apigee_bm_x_api_key"];
    conf.headers["X-Transaction-Id"] = createTransactionID();
    conf.headers["X-Correlation-Id"] = win["xCoId"];
    conf.headers["JourneyName"] = journeyName;
    conf.headers["POID"] = poid;
    conf.headers['X-Timestamp'] = getUTCTime()
    conf.headers['X-Journey-Name'] = JOURNEY_NAME;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

inquiryApi.interceptors.request.use(
  async (conf: any) => {
    const poid = getCookies("device-poid");
    const journeyName = getCookies("device-journeyName");

    conf.baseURL = win['apigee_bm_base_url']
    conf.headers['x-api-key'] = win['apigee_bm_x_api_key']
    conf.headers['X-Transaction-Id'] = createTransactionID()
    conf.headers['X-Correlation-Id'] = win['xCoId']
    conf.headers['JourneyName'] = journeyName
    conf.headers['POID'] = poid;
    return conf
  },
  err => {
    console.log('error in getting ', err)
  }
)

const graphqlApi = (productId: any) => {
  var query =
    `{
    getProductOfferByID(id: "`+ productId + `") {
      id{
        key
        version
    }
    name
    externalID
    createdBy
    createdOn
    stock {
      storeStatus
      warehouseStatus
    }
    attachment {
      url
      name
      description
    }
    productSpecification{
        id
        name
    }
    specCharValueUse{
      name
      specCharacteristicValue{
        value
      }
     
    }  
  category {
      id
      name
      type
      parentId
      isAnchor
      isOfferContainer
      parentHierarchy {
        id
        name
        parentId
        isAnchor
        isOfferContainer
      }
        subCategories {
        id
        name
        visibility
        type
        baseType
        href
        description
        visibilityInSection {
          id
          name
        }
      }
    }
    productOfferingPrice{
      id
      code
      name
      externalID
      processContext{
        id
        name
      }
      priceType
      price{
        unit
        value
      }
    }
      offerLabels{
        name
        description
        channel
      }
    }
  }`;
  return api.post("/catalog-agg-query/graphql", { query: query });
};

const updateAndValidateSc = (cartId: any) => {
  let data = {
    ShoppingCartId: cartId,
  };
  return api.post(
    `/mobily-shopping-cart-management/api/update-and-validate`,
    data
  );
  // return api.get('http://localhost:3001/shoppingCart');
};

const deleteCartItemApi = (req: any, scData: any) => {
  const data: any = {
    context: {},
    existingShoppingCart: scData,
  };

  const url = `/shopping-cart/v3/shoppingCart/${req.scId}/offerContainer/${req.ocId}/cartItem/${req.cId}`;
  return api.delete(url, { data });
};

const cancelShoppingcart = (cartId: any) => {
  let data = {
    context: {},
    shoppingCartPatch: [
      {
        operation: "patch",
        path: "/status",
        value: [
          {
            status: "ABANDONED",
          },
        ],
      },
    ],
  };
  return api.patch(`/api/shopping-cart/v3/shoppingCart/+${cartId}`, data);
  // return api.get('http://localhost:3001/shoppingCart');
};

const callAuditService = (response: any) => {
  const data: any = auditErrorRequest(response);
  return api.post(`/api/mobily-audit-service/audit/save`, data);
};


const getAccountByNumber = (msisdn: any, preOrder: any, accessToken: any) => {
  const journeyName = preOrder === "true" ? 'Devices_Pre-Order' : 'Devices_StandAlone';
  return inquiryApi.get(`/bmi-customer-management/services/customer?MSISDN=${msisdn}&JourneyName=${journeyName}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
  // return api.get('http://localhost:3001/accountByMsisdn');
}


const appleCareGraphqlApi = (seriesId: any) => {

  const query = `{
  getCategoryByID(id: "`+ seriesId + `") {
    id
    name
    internalLifecycleStatus
    productOffers{
      id{
        key
        version
      }
      name
      productSpecification {
        id
        name
      }
      specCharValueUse{
        name
      specCharacteristicValue{
        value
      } 
    }  
      type
      baseType
      pricepoint{
        id
        targetOfferID
        placeID
        priceId
      }
      name
    productOfferingPrice{
      id
      code
      name
      externalID
      processContext{
        id
        name
      }
      priceType
      price{
        unit
        value
      }
      tax
      {
        taxRate
        taxAmount  
        {
            unit
            value
        }    
      }
    }
    }
isAnchor
root
type
  }
}`
  return api.post("/catalog-agg-query/graphql", { query: query });
}

const cemInitiateOTP = (msisdn: any, idNumber: any, lang: string) => {

  const data: any = {
    version: "v1",
    journey: "LOGIN",
    operation: "QUICK_LOGIN",
    language: lang,
    extraInfo: [
      {
        key: "ACCOUNT_NUMBER",
        value: msisdn
      },
      {
        key: "ACCOUNT_TYPE",
        value: "MSISDN"
      },
      {
        key: "ID_NUMBER",
        value: idNumber
      },
      {
        key: "LOGIN_TYPE",
        value: "QUICK"
      }
    ]
  }

  return api.post(`/cem/bff/login/v1/initiate`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });

  // return api.get('http://localhost:3001/cemOTPInitiate'); //success
}

const cemValidateOTP = (req: any) => {

  const data: any = {
    operation: "VALIDATE_LOGIN_BY_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: req?.refId
      },
      {
        key: "OTP",
        value: req?.otp
      },
      {
        key: "IS_OAUTH_TOKEN",
        value: "N"
      },
      {
        key: "CLIENT_ID",
        value: req?.EnBmClientId
      },
      {
        key: "CLIENT_SECRET",
        value: req?.EnBmClientSecret
      }
    ]
  }

  return api.post(`/cem/bff/login/v1/validate`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });

  // return api.get('http://localhost:3001/cemOtpValidate'); //success
}

const cemResendOTP = (refId: any) => {

  const data: any = {
    operation: "RESEND_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: refId
      }
    ]
  }
  return api.put(`/cem/bff/otp/v1/resend`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });
  //  return api.get('http://localhost:3001/installmentCustomerEligibility');
}

const addAppleCare = (acId: string, acName: string, scId: string, ocId: string) => {
  const data = {
    cartItem: [
      {
        action: "Add",
        productOffering: {
          id: acId,
          name: acName
        },
        quantity: 1
      }
    ],
    context: {
      additionalAttributes: []
    }
  }

  return api.post(`/shopping-cart/v3/shoppingCart/${scId}/offerContainer/${ocId}/cartItem`, data);
}

const removeAppleCare = (scId: string, ocId: string, ciId: any) => {
  const data: any = {}

  return api.delete(`/shopping-cart/v3/shoppingCart/${scId}/offerContainer/${ocId}/cartItem/${ciId}`, { data });
}

const captureData = (shoppingCart: any, captureSection: any) => {
  let data: any = {
    context: {
      channel: shoppingCart.channel,
      serviceability: {},
      shoppingCart: shoppingCart
    },
    sections: captureSection
  }
  return api.post(`/checkout-api/v3/checkout/captureData`, data);
}

const getProjectionCheckoutBySCId = (scId: any, validityToken: any) => {
  return api.get('/checkout-projection/v3/checkout/' + scId, {
    headers: {
      'validityToken': validityToken
    }
  });
}

const POQ = (sc: any, ocId: string) => {
  const data: any = {
    channel: {
      id: "bo_lov_android",
      name: "Android"
    },
    context: {
      additionalAttributes: [],
      shoppingCart: sc
    },
    description: "Qualification",
    instantSyncQualification: true,
    place: [],
    productOfferingQualificationItemContainer: [
      {
        category: {
          id: "devices_and_accessories-pc_n6lhq",
          name: "Devices and Accessories"
        },
        id: ocId,
        processContext: "ACQ",
        productOfferingQualificationItem: []
      }
    ],
    "provideAlternative": true,
    "provideUnavailabilityReason": true
  }

  return api.post(`/product-offering-qualification-management/v3/qualifyProducts?parentCategoryfilter=apple_care&isProductDetailRequired=true&fields=po:id,name,specCharValueUse.name,specCharValueUse.specCharacteristicValue.value%26pop:price,tax`, data);
}

const termsInitiateOtp = (number: any, lang: any, otpLength: any, isNumeric: any, journeyName: any, deviceName: any, price: any) => {
  const data = {
    "version": "v1",
    "journey": journeyName,
    "operation": "SEND_OTP",
    "language": lang,
    "extraInfo": [
      {
        "key": "ACCOUNT_NUMBER",
        "value": number
      },
      {
        "key": "OTP_LENGTH",
        "value": otpLength
      },
      {
        "key": "IS_NUMERIC",
        "value": isNumeric
      },
      {
        "key": "DEVICE_NAME",
        "value": deviceName
      },
      {
        "key": "APPLE_CARE_PRICE",
        "value": price
      }
    ]
  }


  // let data = {
  //   version: "v1",
  //   journey: "COMMON",
  //   operation: "SEND_OTP",
  //   language: lang,
  //   extraInfo: [
  //     {
  //       "key": "ACCOUNT_NUMBER",
  //       "value": number,
  //     },
  //     {
  //       "key": "OTP_LENGTH",
  //       "value": otpLength
  //     },
  //     {
  //       "key": "IS_NUMERIC",
  //       "value": isNumeric
  //     },

  //   ]
  // }
  return api.post(`/cem/bff/otp/v1/send`, data);
  // return api.get('http://localhost:3001/cemBffInitiateOtp');
}

const termsValidateOtp = (otp: any, hashCode: any) => {
  let data = {
    operation: "VALIDATE_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: hashCode
      },
      {
        key: "OTP",
        value: otp
      }
    ]
  }
  return api.put(`/cem/bff/otp/v1/validate`, data);
  // return api.get('http://localhost:3001/cemBffValidateOtp');
}

const termsResendOtp = (hashCode: any) => {
  let data = {
    operation: "RESEND_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: hashCode
      }
    ]
  }
  return api.put(`/cem/bff/otp/v1/resend`, data);
}

const getFindInBranch = async (branchData: any) => {
  const data = {
    ...branchData,
    city: branchData.cityName,
    location: {
      lat: String(branchData.location.lat),
      lon: String(branchData.location.lng)
    },
    radius: Number(branchData.radius)
  };
  delete data.location.lng;
  delete data.cityName;

  return api.post(`/cem/bff-stock-management/v1/branchStockAvailability`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });
  // return api.get('https://mocki.io/v1/cf35717d-2734-4010-b716-9e949e288ce8');
}

export {
  graphqlApi,
  updateAndValidateSc,
  deleteCartItemApi,
  cancelShoppingcart,
  callAuditService,
  getAccountByNumber,
  appleCareGraphqlApi,
  cemInitiateOTP,
  cemValidateOTP,
  cemResendOTP,
  addAppleCare,
  removeAppleCare,
  captureData,
  getProjectionCheckoutBySCId,
  POQ,
  termsInitiateOtp,
  termsValidateOtp,
  termsResendOtp,
  getFindInBranch
};
